import React, { useState, useEffect } from "react";
import "./App.css";
import UserInputField from "./components/input/user_input_field";
import Messages from "./components/messages/messages";
import Suggestion from "./components/suggestion/suggestion";
import axios from "axios";
import HeroMessage from "./components/messages/hero/hero_message";

const suggestionMapping = {
  "Jag vill veta mer om Diploma": "about_diploma",
  "Jag vill ha hjälp att hitta rätt kurs": "course_recommendation",
  "Jag vill veta hur era kurser fungerar.": "about_courses",
  "Vad kostar det om flera personer vill köpa?": "about_courses",
  "Vad kostar Premium?": "about_courses",
};

const all_suggestion = {
  course_recommendation: [
    "Rekommendation alt 1",
    "Rekommendation alt 2",
    "Rekommendation alt 3",
  ],
  about_diploma: [
    "Om Diploma alt 1",
    "Om Diploma alt 2",
    "Om Diploma alt 3",
  ],
  about_courses: [
    "Om kurser 1",
    "Om kurser 2",
    "Om kurser 3",
  ],
};

function App() {
  const [minimized, setMinimized] = useState(true);
  const [hasFirstMaximizeOccurred, setHasFirstMaximizeOccurred] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [threeDots, setThreeDots] = useState(false);
  const [firstRecommendation, setFirstRecommendation] = useState(true);
  const [suggestions, setSuggestions] = useState(Object.keys(suggestionMapping));
  const [showSuggestion, setShowSuggestion] = useState(true);
  const [hasShownNotification, setHasShownNotification] = useState(false);
  const [host, setHost] = useState(null);

  const [messages, setMessages] = useState(() => {
    const savedMessages = sessionStorage.getItem("messages");
    return savedMessages
      ? JSON.parse(savedMessages)
      : [
        {
          isUser: false,
          message:
            "Hej, jag heter Smilla och är Diplomas AI-assistent. Hur kan jag hjälpa dig idag?",
        },
      ];
  });

  useEffect(() => {
    // Extract host from URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const currentHost = urlParams.get("host");

    if (currentHost) {

      // Ensure 'https://' is added if missing
      let fullHost = decodeURIComponent(currentHost);
      if (!fullHost.startsWith("https://")) {
        fullHost = `https://${fullHost}`;
      }

      setHost(fullHost);  // Set the host value with 'https://'
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("messages", JSON.stringify(messages));
  }, [messages]);

  // Handle resizing the iframe
  const handleIframeResize = (width, height) => {
    // Send a message to the parent to resize the iframe
    window.parent.postMessage({ type: 'resize', width, height }, '*');
  };

  const handleMinimize = () => {
    setMinimized(true);
    handleIframeResize("80px", "80px"); // Minimized size
  };

  const handleMaximize = () => {
    setMinimized(false);
    setHasShownNotification(true);


    if (window.innerWidth <= 480) {
      handleIframeResize("40vw", "80vh"); // For very small devices
    } else if (window.innerWidth <= 768) {
      handleIframeResize("40vw", "80vh"); // For tablets and small screens
    } else {
      handleIframeResize("40vw", "80vh"); // For larger screens
    }

    if (!hasFirstMaximizeOccurred) {
      setHasFirstMaximizeOccurred(true);
    }
  };


  useEffect(() => {
    if (minimized && !hasShownNotification) {
      const timer = setTimeout(() => {
        setShowNotification(true);
        setHasShownNotification(true);
      }, 5000);

      return () => clearTimeout(timer);
    } else {
      setShowNotification(false);
    }
  }, [minimized]);

  const handleSuggestionClick = async (suggestion) => {
    setSuggestions([]);
    await handleUserSubmit(suggestion);
    setShowSuggestion(false);
    const key = suggestionMapping[suggestion];

    if (key && all_suggestion[key]) {
      setSuggestions(all_suggestion[key]);
    } else {
      setSuggestions(["else Default 1", "else Default 2"]);
    }
  };

  const handleUserSubmit = async (submit) => {
    setShowSuggestion(false);
    setMessages((prevMessages) => [...prevMessages, { isUser: true, message: submit }]);

    const updatedMessages = [...messages, { isUser: true, message: submit }];
    setThreeDots(true);
    setMessages((prevMessages) => [...prevMessages, { isUser: false, message: "" }]);

    try {
      let url = null;
      if (window.location.href.includes("utbildning/")) {
        url = window.location.href.split("utbildning/")[1];
      }
      const response = await axios.post(
        "https://europe-central2-diplomacourseselector.cloudfunctions.net/app/api/FuncCall",
        {
          conversationHistory: updatedMessages,
          currentPageUrl: url,
          firstRecommendation,
        }
      );

      const { AI, content } = response.data;
      const fallbackMessage = "Något gick tyvärr fel, testa igen!";
      //protects agains null or undefined
      const safeContent = content ?? fallbackMessage;

      setMessages((prevMessages) => prevMessages.slice(0, -1));

      if (AI === "courseSelector") {
        setFirstRecommendation(false);
        setMessages((prevMessages) => [
          ...prevMessages,
          { isUser: false, message: `${safeContent.message}` },
        ]);
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            isUser: null,
            message: `jag rekommenderar dessa kurser:  ${JSON.stringify(safeContent.courseDetails)}`,
            courseDetails: safeContent.courseDetails,
          },
        ]);
        if (safeContent.courseDetails.length > 0) {
          setMessages((prevMessages) => [
            ...prevMessages,
            { isUser: false, message: `Klicka på kursen för att ta dig till kurssidan eller ställ dina frågor om dem här i chatten! ` },
          ]);
        }
      } else {
        setMessages((prevMessages) => [
          ...prevMessages,
          { isUser: false, message: safeContent },
        ]);
      }
    } catch (error) {
      console.error(error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { isUser: false, message: "Hoppsan! Något gick fel, vänligen testa igen." },
      ]);
    } finally {
      setThreeDots(false);
    }
  };

  return (
    <>
      <div className={`kursvaljarecoursewrapper ${minimized ? "kursvaljarehidden" : ""}`}>
        <div className="kursvaljareHeader">
          <img src="/images/robotIcon-circle.svg" alt="Diploma Icon" className="kursvaljareHeaderIcon" />
          <div className="kursvaljareIntroduction">
            <span className="chatWith">Prata med</span>
            <span className="smilla">Smilla</span>
          </div>
          <img src="/images/down-arrow.svg" alt="close" className="xClose" onClick={handleMinimize} />
        </div>
        <HeroMessage slogan="Auktoriserat utbildningsföretag" />

        <div className="kursvaljarecontentWrapper">
          <Messages messages={messages} threeDots={threeDots} host={host} />
        </div>
        <div className="bottomContainer">
          {showSuggestion && <Suggestion suggestions={suggestions} onClick={handleSuggestionClick} />}
          <UserInputField onSubmit={handleUserSubmit} />
        </div>
      </div>

      {minimized && (
        <>
          <div className="kursvaljareminimizedButton" onClick={handleMaximize}>
            <img src="/images/robotIcon-circle.svg" alt="Diploma" className="kursvaljareImage" />
          </div>

          {showNotification && (
            <div className="kursvaljareNotificationBubble">
              <p>Hej, har du några frågor kan du ställa dom här!</p>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default App;
